export const WhySection = () => {
  return (
    <section className="why-section">
      <blockquote className="why-quote">
        "When financing is available, clients commit faster, preserve scope,
        and move forward with confidence."
      </blockquote>

      <div className="why-content">
        <h2>
          Design momentum is easier to keep <em>when budget friction drops.</em>
        </h2>
        <p>
          Financing helps qualified homeowners keep liquidity while still saying
          yes to the design plan they actually want. That means fewer mid-project
          compromises and stronger execution.
        </p>
        <p>
          It also elevates your position as an advisor. Instead of reducing scope,
          clients can evaluate payment options that align with their priorities
          and timeline.
        </p>
      </div>
    </section>
  );
};
